import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import LicenseForm from "../components/license/LicenseForm";

const LicenseFormPage = ({ isEdit = false }) => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title={isEdit ? "Edit License" : "Create License"} />

        {/* LicenseForm */}
        <LicenseForm isEdit={isEdit} />
      </MasterLayout>
    </>
  );
};

export default LicenseFormPage;
